/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Discounts {
    "use strict";

    export class DiscountsContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        constructor(
            appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            discountsService: Meevo.Plugins.Discounts.IDiscountsService,
            busyService: Meevo.Components.Busy.IBusyService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);

            this.baseEndpoint = appSettings.API_ENDPOINTS.discount;
            this.sectionTemplatePath = "app/plugins/discounts/sectionViews/";
            this.entityType = 'Discount';

            this.buildCrudSecurityKeys(this.securityKeys.REGISTER_DISCOUNTS_TAB_MAIN);

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.REGISTER_DISCOUNTS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0, "SECTION_MAIN", "main.html", true, false, this.baseEndpoint,
                    "", this.loggingService, this.dataService, discountsService, busyService, identityService, Meevo.Model.NounEnum.DiscountMain, modalService, this.securityKeys.REGISTER_DISCOUNTS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
        }

        initializeSections(): void {


        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
        }

        isSortByProductsVisible() {
            return !(this.selectedSection as Meevo.Plugins.Discounts.MainSection).discountEntityAllSelected;
        }

        save(): angular.IPromise<any> {
            const model = this.selectedSection.model as Meevo.Model.IDiscount;
            
            if (!model.barCode) {
                const section = this.selectedSection as Meevo.Plugins.Discounts.MainSection;

                if (section && section.barCodeRegExp.test(model.displayName) && model.displayName.length < 31) {
                    return section.promptUseDisplayNameForBarcode()
                        .finally(()=>super.save());
                }
            }

            return super.save();
        }
    }
}